module.exports = __webpack_public_path__ + "static/img/fankui.92a452ef.png";